import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { BackBtn, goBack } from '@comm/BackBtn';
import { queryCustomView, queryDepartmentMy } from '@api/crm/crm';
import ConfigItem from './ConfigItem';

const FormItem = Form.Item;

class FormCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
    };
  }

  componentWillMount() {
    this.getMyDepartment();
  }

  getMyDepartment = () => {
    queryDepartmentMy().then(res => {
      if (res.statusCode === 200) {
        const { uuid } = res.data;
        this.departmentUuid = uuid;
        this.getMyCustomView(uuid);
      }
    });
  };

  getMyCustomView = uuid => {
    queryCustomView({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          fields: res.data,
        });
      }
    });
  };

  submit = e => {
    e.preventDefault();
    const { handleSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // delete values.category
        handleSubmit(values);
      }
    });
  };

  render() {
    const { fields } = this.state;
    const { data } = this.props;
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator('province', { initialValue: data ? data.province : '' });
    getFieldDecorator('city', { initialValue: data ? data.city : '' });
    getFieldDecorator('category1', {
      initialValue: data ? data.category1 : '',
    });
    getFieldDecorator('category2', {
      initialValue: data ? data.category2 : '',
    });
    getFieldDecorator('orderName', {
      initialValue: data ? data.orderName : '',
    });
    getFieldDecorator('recommendName', {
      initialValue: data ? data.recommendName : '',
    });
    getFieldDecorator('managerName', {
      initialValue: data ? data.managerName : '',
    });
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15, marginTop: '-45px' }}>
          <BackBtn />
        </div>
        <Card title="基本信息">
          <Row gutter={25}>
            <Col span={12}>
              <FormItem label="客户名称">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: `请输入客户名称` }],
                  initialValue: data.name,
                })(<Input />)}
              </FormItem>
            </Col>
            {fields.map(item => {
              return <ConfigItem key={item.field} field={item} {...this.props} />;
            })}
          </Row>
        </Card>
        <Row>
          <Col span={24} style={{ marginBottom: 15, textAlign: 'right' }}>
            <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
              确定
            </Button>
            <Button onClick={goBack}>取消</Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(FormCustom);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/FormCustom.js